import { Customer } from './interfaces/_customer.model';

export class CustomerObject implements Customer {
    constructor(
        public sCustFull: string,
        public sCustCode: string,
        public nCustID: number,
        public bHasCreditStop: boolean,
        public sCustName: string,
        public sVatNumber: string,
        public sDefaultCurrency?: string
    ) { }
}
